import { useState, useEffect } from 'react';
import { auth } from '../Services/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { authFetch } from '../Utils/FetchUtil';
import { ReactComponent as DefaultUser } from '../../public/icons/user-default.svg';
import { AccountDetail } from './AccountDetail';
import { ModalContentButton } from '../Controls/Button/ModalContentButton';
import './css/AccountBadge.css';

export const AccountBadge: React.FC = () => {

    const [user, setUser] = useState(auth.currentUser);
    const [displayName, setDisplayName] = useState<string | null>(null);
    const [userBadgeBase64, setUserBadgeBase64] = useState<string>();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            setUser(user);

            if (user) {
                // Call your controller to claim session SkitterBooks
                try {
                    await authFetch("/api/session/startaccount", {
                        method: "POST"
                    });
                    console.log("Session SkitterBooks claimed.");
                } catch (error) {
                    console.error("Failed to claim SkitterBooks:", error);
                }

                setDisplayName(user?.displayName);
            }
            else {
                setDisplayName(null);
            }
        });

        return () => unsubscribe();
    }, []);

    interface UserBadgeProps {
        name: string | null | undefined,
        imageBase64: string | null | undefined
    }

    const UserBadge: React.FC<UserBadgeProps> = ({ name, imageBase64 }) => {

        const badgeIcon = imageBase64
            ? <img src={`data:image/jpeg;base64,${imageBase64}`} />
            : name
                ? <span>{name.charAt(0).toUpperCase()}</span>
                : <DefaultUser height={32} width={32} viewBox="0 0 32 32" />

        return (badgeIcon);
    }

    const buttonContent = <div className="account-button-content">
        <div className="account-name">
            <span>{displayName ? displayName : 'Guest'}</span>
        </div>
        <div className="account-badge">
            {
                user ? <UserBadge name={displayName ? displayName : 'Guest'} imageBase64={userBadgeBase64} /> : <DefaultUser height={32} width={32} viewBox="0 0 32 32" />
            }
        </div>
    </div>

    return (
        <div className="account-badge-container">
            <ModalContentButton id="acount-badge" buttonContent={buttonContent} modalTitle={`Profile of ${displayName ? displayName : 'Guest'}`}>
                <div className="account-detail-outer-container">
                    <AccountDetail auth={auth} />
                </div>
            </ModalContentButton>
        </div>
    );
};
